import { SubscriptionStatus } from '@afterpaytouch/portal-api/consumer/subscriptions/marketing/types'

export const convertSubscriptionStatusToBoolean = (status: SubscriptionStatus): boolean => status === 'SUBSCRIBED'
